import { ListSubheader } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { createStyles } from '@material-ui/styles';
import { withNavigation } from '@topconagriculture/frontend-utils';
import { border, toCssValue, transition } from '@topconagriculture/theme';
import cl from 'classnames';
import * as React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { compose, withHandlers, withState } from 'recompose';
import { withBaseProps } from '../Utils';
import { AppSidebarListItem } from './';
const styles = (theme) => createStyles({
    sidebarWrapper: {
        width: 300,
        height: '100%',
        borderRight: border(theme.color.grey.light),
        boxShadow: `2px 1px 5px #ccc`,
        transition: transition(200),
        position: 'relative',
        zIndex: 998,
        backgroundColor: theme.color.background.light,
        paddingBottom: 50,
    },
    sidebarContent: {
        paddingTop: 10,
    },
    collapsedSidebar: {
        width: 67,
    },
    muiSubheader: {
        paddingBottom: 0,
        '& div:last-child': {
            borderBottom: border(theme.color.grey.lightest),
        },
    },
    sidebarSectionHeader: {
        lineHeight: 1,
        padding: toCssValue([12, 16]),
        color: theme.color.grey.default,
        height: 38,
    },
    emptySectionHeader: {
        height: 1,
        margin: toCssValue([18, 0, 19]),
        backgroundColor: theme.color.grey.light,
    },
    collapseToggle: {
        position: 'absolute',
        backgroundColor: theme.color.grey.lightest,
        borderTop: border(theme.color.grey.light),
        bottom: 0,
    },
});
const AppSidebar = (props) => {
    const { classes, sidebarConfig, toggleMenu, menuGroupStatus, collapsedSidebar, t, toggleCollapseSidebar, hasPermissionSelector, handleListItemClick, selectedMenuItemId, preventClickWhenActive, } = props;
    const shouldShowListItem = (hidden = false, permission = '') => {
        if (hidden) {
            return false;
        }
        return permission ? hasPermissionSelector(permission) : true;
    };
    return (React.createElement("div", { className: cl(classes.sidebarWrapper, collapsedSidebar && classes.collapsedSidebar) },
        React.createElement(Scrollbars, { autoHide: true, autoHideTimeout: 500 },
            React.createElement("div", { className: classes.sidebarContent }, sidebarConfig &&
                sidebarConfig.map((group, groupIndex) => {
                    return (React.createElement(List, { classes: {
                            subheader: classes.muiSubheader,
                        }, component: "nav", key: group.header || '' + groupIndex, subheader: group.header ? (!collapsedSidebar ? (React.createElement(ListSubheader, { component: "div", id: "nested-list-subheader", className: classes.sidebarSectionHeader, disableSticky: true }, t(group.header))) : (React.createElement("div", { className: classes.emptySectionHeader }))) : (React.createElement("span", null)) },
                        group.subItems &&
                            group.subItems.map((subItem, subItemIndex) => {
                                return shouldShowListItem(subItem.hidden, subItem.permissionRequired) ? (React.createElement(AppSidebarListItem, { collapsedVersion: collapsedSidebar, key: subItem.label + subItemIndex, label: t(subItem.label), icon: subItem.icon, onClick: handleListItemClick(subItem), isActive: selectedMenuItemId === subItem.id, preventClickWhenActive: preventClickWhenActive, disabled: !subItem.disabled ? !subItem.goTo && !subItem.externalLink : true })) : null;
                            }),
                        group.items &&
                            group.items.map((listItem, listItemIndex) => {
                                return shouldShowListItem(listItem.hidden, listItem.permissionRequired) ? (React.createElement("div", { key: listItem.label + listItemIndex },
                                    React.createElement(AppSidebarListItem, { collapsedVersion: collapsedSidebar, key: listItem.label + listItemIndex, label: t(listItem.label), icon: listItem.icon, onClick: toggleMenu(listItem.groupKey), disabled: listItem.disabled }, !collapsedSidebar ? (menuGroupStatus[listItem.groupKey] ? (React.createElement(ExpandLess, null)) : (React.createElement(ExpandMore, null))) : (React.createElement("span", null))),
                                    listItem.subItems && (React.createElement(Collapse, { key: listItem.groupKey, in: menuGroupStatus[listItem.groupKey], timeout: "auto", unmountOnExit: true },
                                        React.createElement(List, { disablePadding: true }, listItem.subItems.map((subItem, subItemIndex) => {
                                            return shouldShowListItem(subItem.hidden, subItem.permissionRequired) ? (React.createElement(AppSidebarListItem, { collapsedVersion: collapsedSidebar, key: subItem.label + subItemIndex, label: t(subItem.label), icon: subItem.icon, onClick: handleListItemClick(subItem), isActive: selectedMenuItemId === subItem.id, preventClickWhenActive: preventClickWhenActive, isSubItem: true, disabled: !subItem.disabled ? !subItem.goTo && !subItem.externalLink : true })) : null;
                                        })))))) : null;
                            })));
                }))),
        React.createElement(AppSidebarListItem, { className: classes.collapseToggle, collapsedVersion: collapsedSidebar, disableTooltip: true, label: 'Collapse', icon: collapsedSidebar ? 'arrow-right' : 'arrow-left', onClick: toggleCollapseSidebar, preventClickWhenActive: preventClickWhenActive })));
};
const ComposedAppSidebar = compose(withBaseProps({ styles }), withNavigation, withState('collapsedSidebar', 'setCollapsedSidebar', false), withState('menuGroupStatus', 'setMenuGroupStatus', ({ sidebarConfig }) => {
    const initialState = {};
    sidebarConfig.map((group) => group.items && group.items.map((listItem) => (initialState[listItem.groupKey] = listItem.startOpened || false)));
    return initialState;
}), withHandlers({
    handleListItemClick: ({ goTo, handleExternalLink }) => (item) => () => {
        item.goTo ? goTo(item.goTo) : handleExternalLink(item.externalLink);
    },
    toggleCollapseSidebar: ({ setCollapsedSidebar, collapsedSidebar }) => () => {
        setCollapsedSidebar(!collapsedSidebar);
    },
    toggleMenu: ({ setMenuGroupStatus, menuGroupStatus }) => (groupKey) => (e) => {
        setMenuGroupStatus({ ...menuGroupStatus, [groupKey]: !menuGroupStatus[groupKey] });
    },
    handleExternalLink: () => (link) => (e) => {
        if (link) {
            window.open(link);
        }
    },
}))(AppSidebar);
ComposedAppSidebar.displayName = 'AppSidebar';
export default ComposedAppSidebar;
//# sourceMappingURL=AppSidebar.js.map